module.exports = __webpack_public_path__ + "img/mobile_type_five.bab4ffde.png";